import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchGrammarTopicById, fetchGrammarSubTopicById, deleteGrammarSubTopic } from "./adminGrammarService";
import GrammarSubTopicForm from "./GrammarSubTopicForm";
import TopicLinksPanel from "../../content/TopicLinksPanel";
import "../../blog/tongueTwister.css";

const AdminGrammarSubTopicPage = () => {
  const { topicId } = useParams();
  const navigate = useNavigate();

  // view: "list" | "form"
  const [view, setView] = useState("list");
  const [topic, setTopic] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editingSubTopic, setEditingSubTopic] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [linksOpenId, setLinksOpenId] = useState(null);

  useEffect(() => { loadTopic(); }, [topicId]); // eslint-disable-line

  const loadTopic = async () => {
    setLoading(true);
    const res = await fetchGrammarTopicById(topicId);
    if (res.status === 200 && res.data) setTopic(res.data);
    setLoading(false);
  };

  const handleEditSubTopic = async (subTopicId) => {
    const res = await fetchGrammarSubTopicById(subTopicId);
    if (res.status === 200 && res.data) { setEditingSubTopic(res.data); setView("form"); }
  };

  const handleDelete = async (id) => {
    const res = await deleteGrammarSubTopic(id);
    if (res.status === 200 || res.status === 204) { setDeleteId(null); loadTopic(); }
  };

  const onSaved = () => { setView("list"); setEditingSubTopic(null); loadTopic(); };
  const onCancel = () => { setView("list"); setEditingSubTopic(null); };

  if (loading) return <div className="admin-container"><p>Loading…</p></div>;
  if (!topic) return <div className="admin-container"><p>Topic not found</p></div>;

  if (view === "form") {
    return (
      <GrammarSubTopicForm
        subTopic={editingSubTopic}
        grammarTopicId={Number(topicId)}
        onSaved={onSaved}
        onCancel={onCancel}
      />
    );
  }

  return (
    <div className="admin-container">
      <button onClick={() => navigate("/admin/content/grammar")}
        style={{ marginBottom: 16, background: "none", border: "none", color: "#019095", cursor: "pointer", fontWeight: 600 }}>
        ← Back to Topics
      </button>

      <div className="admin-header">
        <h2>{topic.icon} {topic.title}</h2>
        <button onClick={() => { setEditingSubTopic(null); setView("form"); }}>+ New Sub-Topic</button>
      </div>
      <p style={{ color: "#666", marginBottom: 20, fontSize: 14 }}>{topic.description}</p>

      <table className="announcement-table">
        <thead>
          <tr><th>Title</th><th>Sort</th><th>Sections</th><th>Created</th><th>Actions</th></tr>
        </thead>
        <tbody>
          {(!topic.subTopics || topic.subTopics.length === 0) ? (
            <tr><td colSpan="5">No sub-topics yet. Click "+ New Sub-Topic" to add one.</td></tr>
          ) : topic.subTopics.map((st) => (
            <React.Fragment key={st.id}>
              <tr>
                <td style={{ fontWeight: 600 }}>{st.title}</td>
                <td style={{ textAlign: "center" }}>{st.sortOrder ?? "—"}</td>
                <td style={{ textAlign: "center" }}>{st.sectionCount || 0}</td>
                <td style={{ fontSize: 13, color: "#888" }}>{st.createdAt ? new Date(st.createdAt).toLocaleDateString() : "—"}</td>
                <td>
                  <button onClick={() => handleEditSubTopic(st.id)}>Edit</button>
                  <button
                    onClick={() => setLinksOpenId((prev) => prev === st.id ? null : st.id)}
                    style={{ marginLeft: 4, background: linksOpenId === st.id ? "#e0f7fa" : "none", border: "1px solid #019095", color: "#019095", borderRadius: 5, padding: "3px 10px", cursor: "pointer", fontSize: 12 }}
                  >
                    🔗 Links
                  </button>
                  {deleteId === st.id ? (
                    <>
                      <button className="delete-btn" onClick={() => handleDelete(st.id)}>Confirm</button>
                      <button onClick={() => setDeleteId(null)}>Cancel</button>
                    </>
                  ) : (
                    <button className="delete-btn" onClick={() => setDeleteId(st.id)}>Delete</button>
                  )}
                </td>
              </tr>
              {linksOpenId === st.id && (
                <tr>
                  <td colSpan="5" style={{ padding: 0, background: "#f0fafa" }}>
                    <div style={{ padding: "4px 16px 16px" }}>
                      <TopicLinksPanel topicType="GRAMMAR_SUB_TOPIC" topicId={st.id} />
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminGrammarSubTopicPage;
